// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"471":"a504cbf4","589":"4c8a8778","912":"4c8a8778"}[chunkId] + ".chunk.css";
};